export default __webpack_public_path__ + "static/media/phn.312cbbfd.svg";